import axios from 'axios'

export default {
  getCurrentOlympiad() {
    return axios.get('/api/olympiads/current')
  },
  registrationInOlymiad() {
    return axios.post('/api/olympiads/')
  }
}
